const downloadFile = (content, fileType, filename) => {
    const blob = new Blob([content], { type: fileType })
    const a = document.createElement('a')
    a.download = filename
    a.href = URL.createObjectURL(blob)
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':')
    a.style.display = "none"
    a.rel = 'noopener'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500)
}

export default downloadFile